import { validation } from '@ynap/form-utils'

export default function validate(values, props) {
    const { messages } = props
    const errors = {}

    if (validation.isEmpty(values.logonId)) {
        errors.logonId = messages.errors.required({ field: messages.changeEmailForm.newEmail() })
    } else if (!validation.isValidEmail(values.logonId)) {
        errors.logonId = messages.errors.invalid({ field: messages.changeEmailForm.newEmail() })
    }

    if (!values.x_logonPasswordCurrent || !values.x_logonPasswordCurrent.trim()) {
        errors.x_logonPasswordCurrent = messages.errors.required({ field: messages.changeEmailForm.password() })
    }

    return errors
}
